var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cs-button',{staticClass:"csn-channel-follow-button",attrs:{"size":"small","corners":"rounded","fill":_vm.buttonFill},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFollow.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.buttonTitle))])
}
var staticRenderFns = []

export { render, staticRenderFns }